import { FormsService } from "../../../services/forms/forms.service";
import { AuthPayPalUserRequestActionType } from "../types";

export function* authPayPalUserSaga({ payload }: AuthPayPalUserRequestActionType) {
    try {
        const {
            data: { data },
        } = yield FormsService.updatePaymentPayPalAuth(payload);

        if (data) {
            window.handleChange({ id: "payment.paymentMethod.paypal", value: data.paypal });
            window.handleChange({ id: "payment.account.paypal.email", value: payload.email });
        }
    } catch (error) {
        console.log("PayPal Auth Error", error);
        // yield put(Handle Error);
    }
}
